var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"placeholder":_vm.label,"items":_vm.localOptions,"value":_vm.localValue,"item-value":"uuid","item-text":"title"},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }